export var getCurrentRouteSection = function (currentRoute) {
    return currentRoute === null || currentRoute === void 0 ? void 0 : currentRoute.split('.')[0];
};
//# sourceMappingURL=index.js.map